module.exports = __WEBPACK_EXTERNAL_MODULE_47__;


//////////////////
// WEBPACK FOOTER
// external "weaPortalPublic"
// module id = 47
// module chunks = 0